import { queryClient } from '@/lib/tanstack-query'

import { profileAccount } from './profile.gql'

async function getProfileAccount() {
  return queryClient.ensureQueryData(profileAccount.qry())
}

async function profileIsConfirmed(): Promise<boolean> {
  const { getProfile } = await getProfileAccount()
  return !!getProfile.profile.confirmation
}

export { getProfileAccount, profileIsConfirmed }
